// extracted by mini-css-extract-plugin
export default {"wrapper":"_78bb1b5f","arrowLeft":"_660ebc0e","arrowRight":"_5753e2f5"};